import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { ConfigurationSection } from '../../StyleComponents';
import { CompanyNameSetting } from '@shared/ui/organisms/settings/CompanyNameSetting';
import { WhereaboutsIconPackSetting } from '@shared/ui/organisms/settings/WhereaboutsIconPackSetting';
import { SevenDayWorkingWeekSettings } from '@shared/ui/organisms/settings/SevenDayWorkingWeekSettings';
import { LineManagementSettings } from '@shared/ui/organisms/settings/LineManagementSettings';
import { WeeklyNotesSetting } from '@shared/ui/organisms/settings/WeeklyNotesSetting';
import { ShowBirthdaysOnWhereaboutsSetting } from '@shared/ui/organisms/settings/ShowBirthdaysOnWhereaboutsSetting';
import { GlobalEmailRemindersSetting } from '@shared/ui/organisms/settings/GlobalEmailRemindersSetting';
import { SectionSaveButton } from './SectionSaveButton';

interface Props {
  editable: boolean;
}

export function GeneralPanel(props: Props) {
  const { t } = useTranslation();
  return (
    <>
      <HeadlineSmall style={{ marginBottom: 16 }}>{t('company-settings-page.general')}</HeadlineSmall>
      <ConfigurationSection>
        <CompanyNameSetting editable={props.editable} />
      </ConfigurationSection>
      <WhereaboutsIconPackSetting />
      <SevenDayWorkingWeekSettings />
      <LineManagementSettings />
      <WeeklyNotesSetting />
      <ShowBirthdaysOnWhereaboutsSetting />
      <GlobalEmailRemindersSetting />
      <SectionSaveButton disabled={!props.editable} />
    </>
  );
}
